import { create } from "zustand";

export interface User {
  id: string;
  email: string;
  full_name: string | null;
  role: string;
  tenant_id: string | null;
  tenant_name: string | null;
  email_verified: boolean;
}

export interface TenantSummary {
  id: string;
  name: string;
}

interface AppState {
  user: User | null;
  setUser: (user: User | null) => void;
  tenantId: string | null;
  setTenantId: (tenantId: string | null) => void;
  tenant: TenantSummary | null;
  setTenant: (tenant: TenantSummary | null) => void;
}

export const useAppStore = create<AppState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  tenantId: null,
  setTenantId: (tenantId) => set({ tenantId }),
  tenant: null,
  setTenant: (tenant) => set({ tenant }),
}));
